/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentPeoplePersonidCoursesQueryResponse,
  GetApiV1IndividualpaymentPeoplePersonidCoursesPathParams,
  GetApiV1IndividualpaymentPeoplePersonidCoursesQueryParams,
  GetApiV1IndividualpaymentPeoplePersonidCourses401,
  GetApiV1IndividualpaymentPeoplePersonidCourses500,
} from "../../types/individualPaymentController/GetApiV1IndividualpaymentPeoplePersonidCourses.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentPeoplePersonidCourses } from "../../clients/individualPaymentController/getApiV1IndividualpaymentPeoplePersonidCourses.ts";

export const getApiV1IndividualpaymentPeoplePersonidCoursesQueryKey = (
  personId: GetApiV1IndividualpaymentPeoplePersonidCoursesPathParams["personId"],
  params?: GetApiV1IndividualpaymentPeoplePersonidCoursesQueryParams,
) =>
  [
    {
      url: "/api/v1/individualpayment/people/:personId/courses",
      params: { personId: personId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1IndividualpaymentPeoplePersonidCoursesQueryKey = ReturnType<
  typeof getApiV1IndividualpaymentPeoplePersonidCoursesQueryKey
>;

export function getApiV1IndividualpaymentPeoplePersonidCoursesQueryOptions(
  personId: GetApiV1IndividualpaymentPeoplePersonidCoursesPathParams["personId"],
  params?: GetApiV1IndividualpaymentPeoplePersonidCoursesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1IndividualpaymentPeoplePersonidCoursesQueryKey(
    personId,
    params,
  );
  return queryOptions<
    GetApiV1IndividualpaymentPeoplePersonidCoursesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentPeoplePersonidCourses401
      | GetApiV1IndividualpaymentPeoplePersonidCourses500
    >,
    GetApiV1IndividualpaymentPeoplePersonidCoursesQueryResponse,
    typeof queryKey
  >({
    enabled: !!personId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentPeoplePersonidCourses(personId, params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os planos financeiros da pessoa com nome do curso, situação calculada (bolsista, finalizado, em dia, atrasado, inativo), status de bolsa e valor com transferências e descontos abatidos. Filtros por nosso número, nota fiscal e CPF/CNPJ de terceiro. A empresa do usuário autenticado restringe as matrículas. Migrado do legado IndividualPayment/LoadGridDataAsyncCourses. **(Requer Authorization para autenticação)**
 * @summary Retorna os planos financeiros/cursos de uma pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/people/:personId/courses}
 */
export function useGetApiV1IndividualpaymentPeoplePersonidCourses<
  TData = GetApiV1IndividualpaymentPeoplePersonidCoursesQueryResponse,
  TQueryData = GetApiV1IndividualpaymentPeoplePersonidCoursesQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1IndividualpaymentPeoplePersonidCoursesQueryKey,
>(
  personId: GetApiV1IndividualpaymentPeoplePersonidCoursesPathParams["personId"],
  params?: GetApiV1IndividualpaymentPeoplePersonidCoursesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentPeoplePersonidCoursesQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentPeoplePersonidCourses401
          | GetApiV1IndividualpaymentPeoplePersonidCourses500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentPeoplePersonidCoursesQueryKey(personId, params);

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentPeoplePersonidCoursesQueryOptions(
        personId,
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentPeoplePersonidCourses401
      | GetApiV1IndividualpaymentPeoplePersonidCourses500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
